<template>
    <Dialog :visible="showDialog" class="password-popup" :modal="true" :draggable="false">
        <template #container>
            <div class="dialog-header">
                Authentication Required
            </div>
            <div class="dialog-content">
                <span class="text-center">Enter your password to continue.</span>
                <div class="w-full flex flex-column mt-2">
                    <p class="subtitle">Password</p>
                    <div class="flex flex-column w-full">
                        <PasswordInputText v-model:val="passwordVerification" uid="passwordVerification" :isInvalid="incorrectPassword" @update-val="(val) => passwordVerification=val" :focusWhenMounted="true"/>
                            <span v-if="errorPasswordMessage" class="subtext" style="left: 0; top: 2.5rem; color: var(--inputcomponent-invalid-color);">{{ errorPasswordMessage }}</span>
                            <span v-else-if="incorrectPassword" class="subtext" style="left: 0; top: 2.5rem; color: var(--inputcomponent-invalid-color);">The password is incorrect.</span>
                    </div>
                </div>

            </div>
            <div class="dialog-footer">
                <div class="buttons">
                    <ButtonModule type="secondary" severity="normal" label="Cancel" @click="emit('cancel')"/>
                    <ButtonModule type="primary" severity="normal" :label="!isLoading? 'OK' : 'Wait ...'" @click="sendConfirmed" :disabled="!passwordVerification || isLoading"/>
                </div>
            </div>
        </template>
    </Dialog>
</template>

<script setup>
// --- IMPORTS ---
import { ref, toRefs, onMounted, onBeforeUnmount, watchEffect } from 'vue'
// PrimeVue
import Dialog from "primevue/dialog"
// vue
import PasswordInputText from "@/components/Modules/PasswordInputText.vue"
import ButtonModule from "@/components/Modules/ButtonModule"
// Others
import InputsUtils from '@/composables/InputsUtils'
const { isValidPasswordLogin } = InputsUtils()

// --- PROPS ---
const props = defineProps({
    showDialog: Boolean,
    incorrectPassword: Boolean,
    isLoading: Boolean
})
const { showDialog, incorrectPassword } = toRefs(props)

// --- EMITS ---
const emit = defineEmits(['ok','cancel'])

// --- VARIABLES ---
const passwordVerification = ref(null)
const errorPasswordMessage = ref(null)

// Whenever the dialog opens, it should reset the input password
watchEffect(() => {
    if (showDialog.value) { passwordVerification.value = null }
})

// --- Send ---
const sendConfirmed = () => {
    const isValidPasswordMessage = isValidPasswordLogin(passwordVerification.value)
    if (isValidPasswordMessage !== 'success') {
        errorPasswordMessage.value = isValidPasswordMessage;
        passwordVerification.value = null;
        return
    }
    emit('ok', passwordVerification.value)
    errorPasswordMessage.value = null
    passwordVerification.value = null;
}

// --- ENTER key listener ---
onMounted(() => {
    window.addEventListener('keydown', handleKeyPressed)
})
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyPressed)
}) 
const handleKeyPressed = (event) => {
    if (showDialog.value && event.keyCode === 13) { // ENTER
        if (passwordVerification.value) { sendConfirmed() }
    }
}
</script>

<style scoped>
:deep(.p-dialog .p-dialog-header) {
    justify-content: space-between;
}
</style>